import { render } from "./RepoHistoryTemplate.vue?vue&type=template&id=2712a68f&scoped=true"
import script from "./RepoHistoryTemplate.vue?vue&type=script&lang=js"
export * from "./RepoHistoryTemplate.vue?vue&type=script&lang=js"

import "./RepoHistoryTemplate.vue?vue&type=style&index=0&id=2712a68f&scoped=true&lang=css"

import exportComponent from "/Users/edvardaskostkevicius/WebstormProjects/rv_frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2712a68f"]])

export default __exports__